import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchProducers({ organization_id, certification_id, certification_version_id, format_certification_id, current_page }) {
    return RequesterV1.get(
      `organization/certifications/query_formats/list_producers/${organization_id}/${certification_id}/${certification_version_id}/${format_certification_id}/${current_page}/fetch_producers`
    );
  },
  fetchFormatCertification({ organization_id, certification_id, certification_version_id, format_certification_id }) {
    return RequesterV1.get(
      `organization/certifications/query_formats/list_producers/${organization_id}/${certification_id}/${certification_version_id}/${format_certification_id}/fetch_format_certification`
    );
  },
  downloadFormat({ organization_id, certification_id, certification_version_id, format_certification_id, producer_id }) {
    return RequesterV1.get(
      `organization/certifications/query_formats/list_producers/${organization_id}/${certification_id}/${certification_version_id}/${format_certification_id}/${producer_id}/download_format`,
      { responseType: "blob", foo: 'boo' }
    );
  }
};
